// extracted by mini-css-extract-plugin
export default {"card":"faq_card__8wQAf","icon":"faq_icon__0WK1n"};